import React, { useEffect, useState } from "react";
import { Checkbox, Form, FormGroup, FormControl, ControlLabel, Panel, Row, Col } from "react-bootstrap";
import Request from "request";
import Loading from "../../../../Loading";
import Select from "react-select";
import ErrorMessage from "../../../../ErrorMessage";
import cloneDeep from "lodash.clonedeep";
import PanelBody from "react-bootstrap/lib/PanelBody";

export default ({ event, blockProperties, onSave }) => {
    const [banners, setBanners] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    const streamOptions = event.stream?.map((stream) => ({ value: String(stream.id), label: stream.description_ru || stream.description_en }));

    useEffect(() => {
        fetchBanners();
    }, [])

    const fetchBanners = () => {
        Request.get(`/api/cp/event/${event.eventPassword}/banner`)
            .then(banners => setBanners(banners || []))
            .catch((e) => {
                console.error(e);
                setError(true);
            })
            .finally(() => setLoading(false));
    }

    const handleUpdate = (id, field, value) => {
        setBanners(banners => banners.map(banner => banner.id === id ? { ...banner, [field]: value } : banner));
        Request.post(`/api/cp/event/${event.eventPassword}/banner/${id}`, { [field]: value })
            .then(response => console.log(response))
            ;
    }

    const handleDisplayBanners = (checked, bannerID) => {
        let _skipDisplay = cloneDeep(blockProperties?.skipDisplay) || [];
        if (checked) {
            _skipDisplay = _skipDisplay.filter(id => String(id) !== String(bannerID));
        } else {
            _skipDisplay.push(String(bannerID));
        }
        return _skipDisplay;
    }

    if (loading) return <Loading />;
    if (error) return <ErrorMessage>Произошла ошибка при попытке получить список баннеров</ErrorMessage>;
    if (!banners.length) return <div>Реестр баннеров пуст. Вы можете добавить баннеры <a href={`/cp/event/${event.eventPassword}/interactive/banners`} target="_blank">здесь</a></div>;

    return (
        <div>
            {banners.map(banner => {
                const isDisplayed = !blockProperties.skipDisplay?.includes(String(banner.id));
                return <Panel key={banner.id} style={{ marginBottom: "1rem" }}>
                    <PanelBody>
                        <Form>
                            <FormGroup>
                                <Checkbox
                                    checked={isDisplayed}
                                    onChange={(e) => onSave({ skipDisplay: handleDisplayBanners(e.target.checked, banner.id) })}
                                >
                                    Показывать баннер
                                </Checkbox>
                                <a href={banner.link} target="_blank">
                                    <img width="100%" alt="" src={banner.url} style={{ aspectRatio: '40 / 3', objectFit: 'cover', opacity: !isDisplayed ? 0.4 : 1 }} />
                                </a>
                            </FormGroup>
                            {isDisplayed && <div>
                                <FormGroup>
                                    <ControlLabel>Время ротации</ControlLabel>
                                    <FormControl type="number" bsSize="small" name="timeout" value={banner.timeout} onChange={(e) => handleUpdate(banner.id, 'timeout', e.target.value)} />
                                </FormGroup>
                                <FormGroup>
                                    <ControlLabel>Только для этих залов</ControlLabel>
                                    <Select
                                        isMulti
                                        placeholder="Залы не выбраны"
                                        value={streamOptions.filter(({ value }) => blockProperties.targetStreams?.[banner.id]?.includes(value))}
                                        options={streamOptions}
                                        onChange={(value) => onSave({ targetStreams:  { ...(blockProperties.targetStreams || {}), [banner.id]: value.map(item => item.value) } })}
                                    />
                                </FormGroup>
                            </div>
                            }
                        </Form>
                    </PanelBody>
                </Panel>
            })}
        </div>
    )
};
